import {
    tss,
} from 'app/tss'

export default tss.create(() => {
    return {
        container: {
            width: '100%',
            '.MuiDataGrid-main': {
                boxShadow: 'none !important',
                marginTop: 0,
            },
        },
        withRadioSelection: {
            '.MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
                display: 'none',
            },
        },
    }
})
